import LandingPage from '@/components/LandingPage.vue';

const routes =

  {
    path: '',
    component: LandingPage,
    name: 'LandingPage',
    meta:{
      requiredAuth: false
    }
  }

export default routes;
